export enum ErrorViews {
  NOT_FOUND = 'notFound',
  CARD_NOT_FOUND = 'cardNotFound',
  BOARD_NOT_FOUND = 'boardNotFound',
  BOARD_INVITATION_NOT_FOUND = 'boardInvitationNotFound',
  ORG_INVITATION_NOT_FOUND = 'orgInvitationNotFound',
  UNCONFIRMED_BOARD_NOT_FOUND = 'unconfirmedBoardNotFound',
  UNCONFIRMED_ENTERPRISE_NOT_FOUND = 'unconfirmedEnterpriseNotFound',
  UNCONFIRMED_ORG_NOT_FOUND = 'unconfirmedOrgNotFound',
}



// WEBPACK FOOTER //
// ./app/common/data/error-views.ts